import { AuditLogEntity } from '../types/auditLog.types';
import { PaginationParams, ResponseType } from '../types/shared.types';
import { api } from './api';

export const getAuditLogs = (
  params: PaginationParams<{
    query?: string | null;
    from?: string | null;
    to?: string | null;
  }>
) =>
  api.get<ResponseType<AuditLogEntity[]>>(`/v1/audit-logs`, {
    params,
  });
